
import { PackingList, PackingCategory, DEFAULT_CATEGORIES, getDefaultCategories } from './packingTypes';

const LS_KEY_NEW = 'fricamp_packing_lists_v1';
const LS_KEY_OLD = 'fricamp_packing_v2';

function generateId(): string {
  return `list_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`;
}

export function createNewPackingList(name: string, t?: (key: string) => string): PackingList {
  const cats = t ? getDefaultCategories(t) : JSON.parse(JSON.stringify(DEFAULT_CATEGORIES));
  return {
    id: generateId(),
    name,
    categories: cats,
    createdAt: Date.now(),
    updatedAt: Date.now(),
    archived: false,
  };
}

/** Migrate old single-list from fricamp_packing_v2 to new format */
function migrateFromV2(): PackingList[] | null {
  try {
    const raw = localStorage.getItem(LS_KEY_OLD);
    if (!raw) return null;

    const savedCategories: PackingCategory[] = JSON.parse(raw);

    const merged = DEFAULT_CATEGORIES.map(cat => {
      const savedCat = savedCategories.find(c => c.id === cat.id);
      const mergedItems = cat.items.map(item => {
        const savedItem = savedCat?.items.find(i => i.id === item.id);
        return savedItem ? { ...item, checked: savedItem.checked } : item;
      });
      const customs = savedCat?.items.filter(i => i.custom) ?? [];
      return { ...cat, items: [...mergedItems, ...customs] };
    });

    return [{
      id: generateId(),
      name: 'Min pakkeliste',
      categories: merged,
      createdAt: Date.now(),
      updatedAt: Date.now(),
      archived: false,
    }];
  } catch {
    return null;
  }
}

export function loadPackingLists(): PackingList[] {
  try {
    const raw = localStorage.getItem(LS_KEY_NEW);
    if (raw) return JSON.parse(raw);

    // Try migration from old format
    const migrated = migrateFromV2();
    if (migrated) {
      savePackingLists(migrated);
      return migrated;
    }

    return [];
  } catch {
    return [];
  }
}

export function savePackingLists(lists: PackingList[]): void {
  try {
    localStorage.setItem(LS_KEY_NEW, JSON.stringify(lists));
  } catch {}
}
